import type { HTMLAttributes } from 'react';
import React from 'react';
import styled from 'styled-components';
import { MoreLessButton } from './more-less-button';
import { useExpandableItems } from './use-expandable-items';

type ExpandableProps<T> = HTMLAttributes<HTMLDivElement> & {
  itemsContainer: typeof ItemsGroup;
  items: T[];
  limit: number;
  renderItem: (item: T, idx: number) => React.ReactNode;
};

export function Expandable<T>({
  itemsContainer: ItemsContainerComponent = ItemsGroup,
  items,
  limit,
  renderItem,
  ...forwardingProps
}: ExpandableProps<T>) {
  const {
    items: visibleItems,
    expanded,
    canExpand,
    onToggleExpand
  } = useExpandableItems(items, limit);

  return (
    <Container {...forwardingProps}>
      <ItemsContainerComponent>
        {visibleItems.map(renderItem)}
      </ItemsContainerComponent>
      {canExpand && (
        <MoreLessButton expanded={expanded} onClick={onToggleExpand} />
      )}
    </Container>
  );
}

const ItemsGroup = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
